import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, MultiplePathwaysSerivce, StyleManager, UserService } from 'app/core/services';
import { UserInfo } from 'app/core/services/user/user';
import { Subscription } from 'rxjs';
import { RoutePath } from '../../routing/routes';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {
    isDarkTheme: boolean = false;
    isDevsite: boolean | null = false;
    subscription?: Subscription;
    user: UserInfo | null = null;
    role: string = '';

    @Input('isLoginLayout') isLoginLayout: boolean = false;
    @Output() toggleMenu = new EventEmitter();
    
    constructor(
        private router: Router,
        private authService: AuthService,
        private REALService: MultiplePathwaysSerivce,
        private styleManager: StyleManager,
        private userService: UserService,
    ) { 
        this.user = this.userService.User;
        this.role = this.user?.CurrentRole! || '';
    }

    ngOnInit(): void {
        this.subscription = this.styleManager.isDarkTheme.subscribe(darkTheme => this.isDarkTheme = darkTheme);
        this.REALService.DevSiteSubject.subscribe(devsite => this.isDevsite = devsite);
        this.userService.UserSubject.subscribe(user => this.role = user?.CurrentRoleInfo?.RoleName || '');
    }

    onToggleMenu(): void {
        this.toggleMenu.emit();
    }

    onToggleDarkTheme(checked: boolean): void {
        this.styleManager.setDarkTheme(checked);
    }

    login(): void {
        this.router.navigate([RoutePath.Login]);
    }

    logout(): void {
        this.authService.Logout();
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

}
